import { render } from "./modalPrevisualizarPedido.vue?vue&type=template&id=b6a361c8&scoped=true"
import script from "./modalPrevisualizarPedido.vue?vue&type=script&lang=js"
export * from "./modalPrevisualizarPedido.vue?vue&type=script&lang=js"

import "./modalPrevisualizarPedido.vue?vue&type=style&index=0&id=b6a361c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a361c8"]])

export default __exports__